$(document).on("click", ".kg-filters-button", function() {
    $('body').toggleClass('kg_body_facet_active');
    $(".kg-mobile-facets-wrapper").toggleClass("is-active");
});

$(document).on("click", ".kg-sidebar-card .kg-facet-title", function() {
    $(this).toggleClass("active");
    $(this).next(".kg-facet-container").toggle(); // No animation
});
$(document).on("click", ".kg-collection-layout-button", function() {

    const layoutMode = $(this).data("layout-mode");

    const $productList = $(".kg-product-list");

    $productList.removeClass("kg-grid kg-list");

    if (layoutMode === "grid") {
        $productList.addClass("kg-grid");
    } else if (layoutMode === "list") {
        $productList.addClass("kg-list");
    }

    $(".kg-collection-layout-button").removeClass("is-selected");
    $(this).addClass("is-selected");
});
$(document).on("click", ".value-picker-button", function() {
    var isExpanded = $(this).attr("aria-expanded") === "true";
    $(this).attr("aria-expanded", !isExpanded);

    var $selectBox = $(this).next(".kg-value-select-box");
    var isHidden = $selectBox.attr("aria-hidden") === "true";
    $selectBox.attr("aria-hidden", !isHidden);
});

$(document).on("click", function(event) {
    var $trigger = $(".value-picker-button"); // The button that triggers the dropdown
    if (!$trigger.is(event.target) && !$trigger.has(event.target).length) {
        $(".kg-value-select-box").attr("aria-hidden", "true"); // Hide the dropdown
        $(".value-picker-button").attr("aria-expanded", "false"); // Update button's aria-expanded attribute
    }
});

$(document).ready(function() {
    $("document").on("click", ".kg-facets-value-name", function(){
        const $radio = $(this).find("input[type='radio']");
        $radio.prop("checked", true);
    });
});
$(document).ready(function() {
    $("body").on("click", ".kg-multi-active .kg-facets-value-name", function(){
        const $checkbox = $(this).find("input[type='checkbox']");
        console.log($checkbox);
        if ($checkbox.length) {
            // Toggle the checkbox checked state
            $checkbox.prop("checked", !$checkbox.prop("checked")).trigger('change');

            // Add or remove the 'multi-active' class based on the checkbox state
            if ($checkbox.prop("checked")) {
                $(this).addClass("multi-active");
            } else {
                $(this).removeClass("multi-active");
            }
        }
    });
})
$(document).on("click", ".kg-multi-active.kg-color-facet .kg-facets-value-name", function() {
    $(this).toggleClass("multi-active");
});

$(document).on("click", ".kg-single-active .kg-facets-value-name", function() {
    $(".kg-single-active .kg-facets-value-name").removeClass("active");
    $(this).addClass("active");
});

$(document).ready(function() {
    $(".kg-toggle-child-icon").on("click", function() {
        $(this).closest(".kg-facet-value-dropdown").toggleClass("kg-active");
    });
});

$(document).on("click", ".kg-mobile-facet-values .kg-card-facet .kg-facet-title", function(event) {
    $('.kg-facet-header').toggleClass('kg_facet_active');

    $('.kg-facet-header .kg-facts-current-title').text($(this).parents('.kg-card-facet').find('.kg-facet-title button').text());


    $(this).parents('.kg-card-facet').toggleClass('kg_facet_active');
});

$(document).on("click", ".kg-facet-header", function(event) {
    $('.kg_facet_active').removeClass('kg_facet_active');
    $(this).find('.kg-facts-current-title').text('');
});

$(document).on("click", ".kg-collection__toolbar .kg-collection__layout-button", function() {
    $('.kg-collection__toolbar .kg-collection__layout-button').removeClass('is-selected')
    $(this).toggleClass('is-selected')
    if ($(this).data('layout-mode') == 'list') {
        $('.kg-collection-toolbar button[data-layout-mode="list"]').click()
    } else {
        $('.kg-collection-toolbar button[data-layout-mode="grid"]').click()
    }
});